const e=(e,t,n)=>`<${t} class="${n}">${e}</${t}>`;export{e as wrapWithElement};
//# sourceMappingURL=wrap-with-element.js.map